import { Component, Input } from '@angular/core';
import {
  BsModalRef,
  BsModalService,
} from 'ngx-bootstrap/modal';
import {
  InfoPageDialogComponent,
  InfoPageTemplate,
} from 'src/app/components';

@Component({
  selector: 'app-consent-proctoring-page',
  templateUrl: './consent-proctoring-page.component.html',
  styleUrls: ['./consent-proctoring-page.component.scss'],
})
export class ConsentProctoringPageComponent {
  modalRef?: BsModalRef;

  @Input() showBreadcrumb = true;

  constructor(private modalService: BsModalService) {}

  openPrivacyTerms(pageTemplate: string) {
    this.modalRef = this.modalService.show(
      InfoPageDialogComponent,
      {
        class: 'modal-lg',
        initialState: {
          template: pageTemplate as InfoPageTemplate,
        },
      }
    );
  }
}
